import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  AlertController,
  ModalController,
  NavController,
  PopoverController,
} from '@ionic/angular';
import { PropositionMenuOption } from '../proposition-menu/proposition-menu.component';
import { BoostModalComponent } from '../../modals/boost-modal/boost-modal.component';
import { ShareModalComponent } from '../../modals/share-modal/share-modal.component';
import { environment } from '@shared-envs';
import {
  IdeaService,
  ProblemService,
  PropositionService,
} from '@arkius/shared-api';
import { Observable, take } from 'rxjs';
import { StatsPopoverComponent } from '../stats-popover/stats-popover.component';

@Component({
  selector: 'ark-lib-proposition',
  templateUrl: './proposition.component.html',
  styleUrl: './proposition.component.css',
})
export class PropositionComponent {
  deleteButtons = ['Action'];

  private _item: any;
  get item(): any {
    return this._item;
  }

  @Input() cost: number | null = null;
  @Input() set item(v: any) {
    this._item = v;

    const plainTextTitle = this.stripHtmlTags(v.title);
    // environment.log(v.isMine, plainTextTitle)
    if (v.isMine) {
      this.menuOptions = [
        // {
        //   name: 'Boost',
        //   icon: 'rocket',
        //   handler: async () => {
        //     const modal = await this.modalCtrl.create({
        //       initialBreakpoint: 1,
        //       breakpoints: [0, 0.5],
        //       componentProps: { id: this.item.propositionId },
        //       component: BoostModalComponent,
        //     });
        //     await modal.present();

        //     const { data, role } = await modal.onWillDismiss();
        //     if (role === 'confirm') {
        //       environment.log(data);
        //     }
        //   },
        // },
        {
          name: 'Manage',
          icon: 'settings',
          handler: () => {
            let type: string;
            switch (this.item.type) {
              case 'thinkTank':
                type = 'thinktank';
                break;
              case 'idea':
                type = 'idea';
                break;
              case 'problem':
                type = 'problem';
                break; 
              default:
                type = 'solution';
                break;
            }
            this.navController.navigateForward(
              `/create/${type}/${this.item.propositionId}`,
            );
          },
        },
        {
          name: 'Delete',
          icon: 'trash',
          cssClass: 'text-red-500',
          cssIconClass: '[&>svg>path]:stroke-red-500',
          handler: async () => {
            const alert = await this.alertController.create({
              header: 'Delete Confirmation',
              message: `Are you sure you want to delete ${plainTextTitle}??`,
              buttons: [
                {
                  text: 'Cancel',
                  role: 'cancel',
                },
                {
                  text: 'Delete',
                  cssClass: '!text-red-500',
                  role: 'delete',
                },
              ],
            });

            await alert.present();

            const { role } = await alert.onWillDismiss();
            if (role === 'delete') {
              this.deleteEntity(v)
                .pipe(take(1))
                .subscribe(() => {
                  this.deleted.emit(v.propositionId);
                });
            }
          },
        },
      ];
      // environment.log(this.menuOptions)
      // if (!v.isDraft) {
      //   this.menuOptions.splice(0, 1);
      // }
      if (v.isModerated) {
        this.menuOptions = [];
      }
    } else if (v.type !== 'idea' && v.type !== 'problem') {
      this.menuOptions = [
        // {
        //   name: 'Boost',
        //   icon: 'rocket',
        //   handler: async () => {
        //     const modal = await this.modalCtrl.create({
        //       initialBreakpoint: 1,
        //       breakpoints: [0, 0.5],
        //       componentProps: { id: this.item.propositionId },
        //       component: BoostModalComponent,
        //     });
        //     await modal.present();

        //     const { data, role } = await modal.onWillDismiss();
        //     if (role === 'confirm') {
        //       environment.log(data);
        //     }
        //   },
        // },
        {
          separatorName: 'REPORT',
          mine: true,
        },
        {
          name: 'Report illegal content',
          icon: 'report-flag',
          handler: () =>
            this.navController.navigateForward(
              `/report/${this.item.propositionId}/solution/illegal-content`,
            ),
        },
        // {
        //   name: 'Submit as inaccurate',
        //   icon: 'report-inaccurate',
        //   handler: () =>
        //     this.navController.navigateForward(
        //       `/report/${this.item.propositionId}/solution/inaccurate`,
        //     ),
        // },
        {
          name: 'Submit as inappropriate',
          icon: 'report-inappropriate',
          handler: () =>
            this.navController.navigateForward(
              `/report/${this.item.propositionId}/solution/inappropriate`,
            ),
        },
      ];
    }
  }

  @Input() useTeaserText = false;
  @Input() showFlaggedOverlay = true;
  @Input() menuPosition: 'top' | 'bottom' = 'bottom';
  private _enableCenteredVideoAutoplay = false;
  @Input() set enableCenteredVideoAutoplay(value: boolean) {
    this._enableCenteredVideoAutoplay = value;
  }
  get enableCenteredVideoAutoplay(): boolean {
    return this._enableCenteredVideoAutoplay;
  }

  @Output() upvoted = new EventEmitter<any>();
  @Output() downvoted = new EventEmitter<any>();
  @Output() deleted = new EventEmitter<any>();

  @ViewChild('proposition') propositionElement!: ElementRef<HTMLElement>;
  detail!: any;

  menuOptions: PropositionMenuOption[] = [];

  constructor(
    private navController: NavController,
    private modalCtrl: ModalController,
    private ideaService: IdeaService,
    private problemService: ProblemService,
    private propositionService: PropositionService,
    private alertController: AlertController,
    private popoverController: PopoverController,
  ) {}

  private deleteEntity(item: any): Observable<any> {
    const id = item.propositionId;

    if (item.type === 'idea') {
      return this.ideaService.apiV5IdeaIdDelete(id);
    }

    if (item.type === 'problem') {
      return this.problemService.apiV5ProblemIdDelete(id);
    }

    return this.propositionService.apiV5PropositionIdDelete(id);
  }

  onClick() {
    if (this.item.type === 'idea') {
      this.navController.navigateForward(
        `/idea/${this.item.entityId ?? this.item.propositionId}/details`,
      );
    } else if (this.item.type === 'thinkTank') {
        this.navController.navigateForward(
          `/thinktank/${this.item.entityId ?? this.item.propositionId}/details`,
      );
    } else if (this.item.type === 'problem') {
        this.navController.navigateForward(
          `/problem/${this.item.problemId ?? this.item.propositionId}/details`,
      );  
    } else {
        this.navController.navigateForward(
          `/solution/${this.item.entityId ?? this.item.propositionId}/details`,
      );
    }
  }

  onNicknameClick(event: Event) {
    event.preventDefault();
    event.stopPropagation();
    this.navController.navigateForward(
      `/account/profile/${this.item.userId ?? this.item.createdByUserId}`,
    );
  }

  openShareModal(event: Event) {
    event.stopPropagation();

    const caseUrl: URL = new URL(
      `${environment.devUrl}/solution/${
        this.item.entityId ?? this.item.problemId ?? this.item.propositionId
      }/details`,
    );

    this.modalCtrl
      .create({
        initialBreakpoint: 1,
        breakpoints: [0, 0.75],
        componentProps: {
          id: this.item.propositionId,
          type: this.item.type,
          caseUrl: caseUrl,
        },
        component: ShareModalComponent,
      })
      .then((modal) => {
        modal.present();

        modal.onWillDismiss().then(({ data, role }) => {
          if (role === 'confirm') {
            environment.log(data);
          }
        });
      });
  }

  // onUpvote(event: Event) {

  //   event.preventDefault();
  //   event.stopPropagation();

  //   if (this.item.isMine) return;
  //   this.upvoted.emit(this.item);
  // }

  // onDownvote(event: Event) {

  //   event.preventDefault();
  //   event.stopPropagation();

  //   if (this.item.isMine) return;
  //   this.downvoted.emit(this.item);
  // }

  private stripHtmlTags(html: string): string {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || '';
  }

  async openStatsPopover(event: Event) {
    event.preventDefault();
    event.stopPropagation();

    const modal = await this.modalCtrl.create({
      component: StatsPopoverComponent,
      componentProps: {
        ratingAverage: this.item.rating,
        ratingCount: this.item.ratingCount,
        shareCount: this.item.shareCount,
        membersFollowing: this.item.subscriberCount,
        averageCommitmentLevel:
          this.item.averageCommitmentLevel != null
            ? this.item.averageCommitmentLevel
            : null,
        commentCount: this.item.commentCount,
        // uniqueViews: this.item.receivedCount,
        backedCount: this.item.type !== 'idea' && this.item.type !== 'problem' ? this.item.backedCount : null,
        userIndex: this.item.userIndex,
        userIndexDiff: this.item.userIndexDetails?.userIndexDiff,
        userIndexAmbassador: this.item.userIndexDetails?.userIndexAmbassador,
        userIndexCreator: this.item.userIndexDetails?.userIndexCreator,
        userIndexHelper: this.item.userIndexDetails?.userIndexHelper,
      },
      // event: event,
      // translucent: true,
      // showBackdrop: false,
      // backdropDismiss: true,
      // animated: true,
      // size: 'auto',
      // side: 'start',
      cssClass: 'max-h-300',
    });

    environment.log('modal.componentProps', modal.componentProps);

    const modalElement = modal.shadowRoot?.querySelector(
      '.modal-wrapper',
    ) as HTMLElement;
    if (modalElement) {
      modalElement.style.width = '65%';
      modalElement.style.maxWidth = '400px';
      modalElement.style.borderRadius = '8px';
    }

    await modal.present();
  }

  getItemTypeLabel(item: any): string {
    if (item.type === 'idea' || item.ideaId) {
      return 'Idea';
    }

    if (item.type === 'problem' || item.problemId) {
      return 'Problem';
    }

    if (item.isDraft === true) {
      if (item.type === 'thinkTank') {
        return 'Draft Think Tank';
      }
      return 'Draft Solution';
    }

    if (item.type === 'thinkTank') {
      return 'Think Tank';
    }

    return 'Solution';
  }

  getItemIdentifier(item: any): number | string | null {
    if (item.type === 'idea') {
      return item.ideaId ?? item.propositionId ?? null;
    }

    if (item.type === 'problem') {
      return item.problemId ?? item.propositionId ?? null;
    }

    return item.incrementalIdentifier ?? null;
  }
}
